import * as React from 'react';

function CloseButtonRound(props) {
    return (
        <svg
            width={40}
            height={40}
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M30.5 20C30.5 25.799 25.799 30.5 20 30.5C14.201 30.5 9.5 25.799 9.5 20C9.5 14.201 14.201 9.5 20 9.5C25.799 9.5 30.5 14.201 30.5 20ZM32 20C32 26.6274 26.6274 32 20 32C13.3726 32 8 26.6274 8 20C8 13.3726 13.3726 8 20 8C26.6274 8 32 13.3726 32 20ZM25 15.9091L24.0909 15L20 19.0909L15.9091 15L15 15.9091L19.0909 20L15 24.0909L15.9091 25L20 20.9091L24.0909 25L25 24.0909L20.9091 20L25 15.9091Z"
            fill="#fff"
            />
        </svg>
    );
}

export default CloseButtonRound;
